import { type FC, type ReactNode, useState } from "react";

const PencomCheckBox: FC<{
    id: string;
    name: string;
    value: string;
    label?: string;
    onToggle?: (checked: boolean) => void;
    inputClassName?: string;
    labelClassName?: string;
    labelField?: ReactNode;
    isChecked?: boolean;
    tooltip?: string;
}> = ({
    id,
    name,
    value,
    onToggle,
    inputClassName = "",
    labelClassName = "",
    isChecked = false,
    labelField,
    label,
}) => {
        const [checked, setChecked] = useState(isChecked);

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const checked = event.target.checked;
            setChecked(checked);
            if (onToggle) {
                onToggle(checked);
            }
        };

        return (
            <div className="flex items-center">
                <input
                    type="checkbox"
                    id={id}
                    name={name}
                    value={value}
                    className={`hidden ${inputClassName}`}
                    onChange={handleChange}
                    checked={checked}
                />
                <label
                    htmlFor={id}
                    className={`flex cursor-pointer items-center text-sm tracking-[-0.5%] font-clash-display font-medium leading-4.5 text-medium-dark-grey ${labelClassName} ${checked ? "text-neutral-900" : ""
                        }`}
                >{
                        <div className="mr-2 flex-shrink-0">

                            <img
                                src={
                                    checked
                                        ? "/assets/icons/checkbox-checked.svg"
                                        : "/assets/icons/checkbox-unchecked.svg"
                                }
                                alt={checked ? "checked" : "unchecked"}
                                className={`transition-transform duration-300 ease-in-out ${checked ? "scale-100" : "scale-95"
                                    }`}
                            />

                        </div>
                    }

                    {labelField ? labelField : <div className="flex-grow">{label}</div>}
                </label>
            </div>
        );
    };

export default PencomCheckBox;
